import SoundWave from './SoundWave';

export default SoundWave;
